import {Button, Input, Row, Space, Typography, Radio, Col, Form} from "antd";
import React, {useEffect, useState} from "react";
import Icons from "assets/icons";
import "./InjuryExpand.scss";
import {InputFields} from "components/common";
import {
  fieldsInjuryRight,
  fieldsInjuryLeft,
  fieldsOpenGlobeRight,
  fieldsOpenGlobeLeft,
  fieldsLamellarRight,
  fieldsLamellarLeft,
  fieldsClosedGlobeLeft,
  fieldsClosedGlobeRight,
  fieldsRuptureRight,
  fieldsRuptureLeft,
  fieldsIOFBRight,
  fieldsIOFBLeft,
  fieldsStoneRight,
  fieldsStoneLeft,
  fieldsCommentLeft,
  fieldsCommentRight,
} from "./InjuryExpand.config";
import {useAppSelector} from "redux/hooks";

type Props = {
  isOpen: boolean;
  setIsOpen: () => void;
  index: number;
};

const InjuryExpand = ({isOpen, setIsOpen, index}) => {
  const [form] = Form.useForm();
  const [globe, setGlobe] = useState();
  const [rupture, setRupture] = useState<boolean>(false);
  const [iofb, setIofb] = useState<boolean>(false);
  const [stone, setStone] = useState<boolean>(false);
  const [lamellar, setLamellar] = useState<boolean>(false);
  const objectChanDoan = useAppSelector(
    state => state.examination.objectChanDoan
  );
  const ref = useAppSelector(state => state.examination.ref);
  useEffect(() => {
    if (index == 0) {
      fieldsInjuryRight.find(e => e.label == "Tình trạng nhãn cầu:").onChange =
        e => {
          setGlobe(e.target.value);
        };
      fieldsOpenGlobeRight.find(
        e => e.label == "Chấn thương nhãn cầu hở:"
      ).onChange = e => {
        setRupture(e?.includes("Chấn thương đụng dập"));

        setIofb(e?.includes("Dị vật nội nhãn"));
      };
      fieldsIOFBRight.find(e => e.label == "Dị vật nội nhãn").onChange = e => {
        setStone(e?.includes("Đá"));
      };
      fieldsClosedGlobeRight[0].onChange = e => {
        setLamellar(e?.includes("Rách tách lớp"));
      };
    } else {
      fieldsInjuryLeft.find(e => e.label == "Tình trạng nhãn cầu:").onChange =
        e => {
          setGlobe(e.target.value);
        };
      fieldsOpenGlobeLeft.find(
        e => e.label == "Chấn thương nhãn cầu hở:"
      ).onChange = e => {
        setRupture(e?.includes("Chấn thương đụng dập"));
        setIofb(e?.includes("IOFB"));
      };
      fieldsIOFBLeft.find(e => e.label == "Dị vật nội nhãn").onChange = e => {
        setStone(e?.includes("Đá"));
      };
      fieldsClosedGlobeLeft[0].onChange = e => {
        setLamellar(e?.includes("Rách tách lớp"));
      };
    }
  }, []);
  useEffect(() => {
    if (!isOpen) {
      // const fieldsValue = ref.getChanDoanValue();
      if (ref) {
        ref.setFieldValue(
          [`${index == 1 ? "leftJsonValue" : "rightJsonValue"}`, "INJURY"],
          null
        );
      }
    }
    if (ref) {
      ref.setFieldValue(
        [
          `${index == 1 ? "leftJsonValue" : "rightJsonValue"}`,
          "INJURY",
          "show",
        ],
        isOpen
      );
    }
  }, [isOpen, ref]);
  useEffect(() => {
    if (objectChanDoan && ref) {
      const show = ref.getFieldValue([
        `${index == 1 ? "leftJsonValue" : "rightJsonValue"}`,
        "INJURY",
        "show",
      ]);
      if (Boolean(show) == true && isOpen == false) {
        setIsOpen();
      }
      if (Boolean(show) == false && isOpen == true) {
        setIsOpen();
      }
    }
  }, [objectChanDoan, ref]);
  return (
    <Space
      direction="vertical"
      className="space-common space-injury"
      size={"middle"}
    >
      <Row justify={"start"} className="row-common">
        <Button
          type="primary"
          icon={isOpen ? <Icons.sub rev={0} /> : <Icons.add rev={0} />}
          onClick={setIsOpen}
        />
        <Typography className="title-common-healthy">CHẤN THƯƠNG</Typography>
      </Row>
      {/* <Row>
        <Col>Nature Of Injury:</Col>
        <Col></Col>
      </Row> */}

      {isOpen ? (
        <div>
          <Row gutter={[16, 8]}>
            <InputFields
              data={index == 0 ? fieldsInjuryRight : fieldsInjuryLeft}
            />

            {globe == "Chấn thương nhãn cầu hở" && (
              <>
                <InputFields
                  data={index == 0 ? fieldsOpenGlobeRight : fieldsOpenGlobeLeft}
                />
                {rupture && (
                  <InputFields
                    data={index == 0 ? fieldsRuptureRight : fieldsRuptureLeft}
                  />
                )}
                {iofb && (
                  <InputFields
                    data={index == 0 ? fieldsIOFBRight : fieldsIOFBLeft}
                  />
                )}
                {stone && (
                  <InputFields
                    data={index == 0 ? fieldsStoneRight : fieldsStoneLeft}
                  />
                )}
              </>
            )}
            {globe == "Chấn thương nhãn cầu kín" && (
              <>
                <InputFields
                  data={
                    index == 0 ? fieldsClosedGlobeRight : fieldsClosedGlobeLeft
                  }
                />
                {lamellar && (
                  <InputFields
                    data={index == 0 ? fieldsLamellarRight : fieldsLamellarLeft}
                  ></InputFields>
                )}
              </>
            )}
            <InputFields
              data={index == 0 ? fieldsCommentRight : fieldsCommentLeft}
            ></InputFields>
          </Row>
        </div>
      ) : null}
    </Space>
  );
};

export default InjuryExpand;
